import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../../services/common/auth.service';

@Component({
  selector: 'app-appointment-request-new',
  templateUrl: './appointment-request-new.component.html',
  styleUrls: ['./appointment-request-new.component.css'],
})
export class AppointmentRequestNewComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {
    this.authService.fetchUserGroups().then((groups) => {
      if (!this.authService.getUser().is('attorney superuser tech')) this.router.navigateByUrl('/appointment_requests');
    });
  }

  ngOnInit() {}
}
